/**
 * 요금 시뮬레이션 분석 화면 공용 포맷터
 */

export function isNum(value) {
    return value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));
}

export function num(value, decimals = 0) {
    if (!isNum(value)) return "-";
    return Number(value).toLocaleString("ko-KR", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}

export function won(value) {
    return isNum(value) ? `${num(value)}원` : "-";
}

/** 축·카드용 축약 금액 (예: 1,234만, 1.2억) */
export function wonShort(value) {
    if (!isNum(value)) return "-";
    const n = Number(value);
    const abs = Math.abs(n);
    if (abs >= 100000000) return `${(n / 100000000).toFixed(abs >= 1000000000 ? 0 : 1)}억`;
    if (abs >= 10000) return `${num(Math.round(n / 10000))}만`;
    return num(n);
}

export function pct(value, decimals = 1, signed = false) {
    if (!isNum(value)) return "-";
    const n = Number(value);
    const sign = signed && n > 0 ? "+" : "";
    return `${sign}${n.toFixed(decimals)}%`;
}

export function signedWon(value) {
    if (!isNum(value)) return "-";
    const n = Number(value);
    return `${n > 0 ? "+" : ""}${num(n)}원`;
}

/** YYYYMM → "M월" / "YY.M" (연도가 바뀌는 지점 구분용) */
export function ymShort(regYm, withYear = false) {
    const s = String(regYm || "");
    if (s.length !== 6) return s;
    const month = parseInt(s.substring(4, 6), 10);
    return withYear ? `${s.substring(2, 4)}.${month}` : `${month}월`;
}

export function ymLabel(regYm) {
    const s = String(regYm || "");
    if (s.length === 6) return `${s.substring(0, 4)}년 ${parseInt(s.substring(4, 6), 10)}월`;
    if (s.length === 4) return `${s}년`;
    return s;
}

export function usageFeeLabel(energySourceCode) {
    return energySourceCode === "Elec" ? "전력량요금" : "사용량요금";
}
